import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-hot-toast";
import useDashboardStore from "../../../../stores/dashboard";
import styles from "./styles.module.scss";
import Checkbox from "../../../../components/Checkbox/Index";
import Button from "../../../../components/new-button";
import {
  getUserPortfolioSetting,
  saveUserPortfolioSetting,
} from "../../../../../api";

const sectionList = [
  { key: "number_statistic", label: "Number statistic" },
  { key: "total_transactions", label: "Total portfolio transactions" },
  { key: "monthly_goals", label: "Monthly goals" },
  { key: "industries", label: "Industries (MCC)" },
  { key: "applications", label: "Applications" },
  { key: "active_merchants", label: "Active merchants" },
  { key: "chargebacks", label: "Chargebacks" },
  { key: "top_residuals", label: "Top residuals" },
  { key: "merchant_attrition", label: "Merchant Attrition" },
];

export default function Settings({apply, cancel}) {

  const [appliedSections, setAppliedSections] = useState([]); 
  const [tempSections, setTempSections] = useState([...appliedSections]);
  const setSettingOpen = useDashboardStore((state) => state.setSettingOpen);
  const setSettingData = useDashboardStore((state) => state.setSettingData);

  const toggleSection = (key) => {
    setTempSections((prev) =>
      prev.includes(key)
        ? prev.filter((s) => s !== key)
        : [...prev, key]
    );
  };

  const handleApply = async() => {
    setAppliedSections(tempSections);
    setSettingOpen(false);

    // ✅ Convert array back → object of booleans
    const savePayload = {};
    sectionList.forEach((s) => {
      savePayload[s.key] = tempSections.includes(s.key);
    });

    try {
      const saveResponse = await saveUserPortfolioSetting(savePayload);

      if(saveResponse?.success){        
        setSettingData(saveResponse?.data);
        toast.success("Settings saved successfully");
      } else {
        toast.error("Failed to save settings");
      }

    } catch (err) {
      console.error("Error saving sections", err);
      toast.error("Failed to save settings");
    }
  };

  const handleCancel = () => {
    setTempSections(appliedSections); 
    setSettingOpen(false);
  };

  const fetchSetting = useCallback(async () => {
    try {
      const settingResponse = await getUserPortfolioSetting();
      const dbRow = settingResponse?.data;

      if (dbRow) {
        // convert boolean fields → array
        const selected = sectionList
          .filter((s) => dbRow[s.key] === true)
          .map((s) => s.key);

        setAppliedSections(selected);
        setTempSections(selected);
      } else {
        // no record → default = all selected
        const allKeys = sectionList.map((s) => s.key);
        setAppliedSections(allKeys);
        setTempSections(allKeys);
      }
    } catch (error) {
      console.error("Error fetching sections:", error);
      toast.error("Error loading sections");
    } finally {
    }
  }, []);

  useEffect(() => {
    fetchSetting();
  }, []);


  return (
    <div className={styles.menuList}>
      <div className={styles.container}>
        SHOW
      </div>
      <div className={styles.checkboxInputs}>
        {sectionList.map((section) => (
        <div className={styles.formCheckbox}>
          <Checkbox
            label={section.label}
            id={section.key}
            name={section.key}
            value={section.key}
            checked={tempSections.includes(section.key)}
            onChange={(e) => toggleSection(section.key)}
          />
          <label htmlFor={section.key}>{section.label}</label>
        </div>
        ))}        
      </div>
      <div className={styles.footer}>
        <div className={styles.actions}>
        <Button
          variant="secondary"
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleApply}
        >
          Apply
        </Button>
        </div>
      </div>
    </div>
  );
}
